// Stored mime types are not always bare: some were copied from a CDN Content-Type header
// ("application/pdf; charset=utf-8") or saved with quotes ('"application/pdf"').
// Strict comparisons against such values silently fail, so every check must normalize first.
export function normalizeMimeType (mimeType) {
  if (typeof mimeType !== 'string') return ''

  return mimeType
    .split(';')[0]
    .replace(/["']/g, '')
    .trim()
    .toLowerCase()
}
